export enum ActionItems {
    AcceptableFullyConfident = 1,
    AcceptableNotFullyConfident = 2,
    NotAcceptable = 3,
    DeclineForAllRecipients = 4,
    DonorHlaFile = 5,
    Donor3GTypingReport = 6,
    VRLConfirmatoryTypingReport = 7,
    ViewDonorCTStudy = 8,
    DonorCTReport = 9,
    RequestInfo = 10,
    RequestExm = 11,
    RequestExmFreshBlood = 12,
    DonorMolecularAboFile = 13
};
